/** External Bookers backend admin (venue / product login). */
export const ADMIN_LOGIN_URL = "https://backend.wearebookers.com/admin/login";
